import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { listerClickThrough } from '../../../../actions/lister-actions';
import AddToBasketButton from '../../../ProductCard/AddToBasket/AddToBasketButton';
import BackInStockButton from '../../../ProductCard/BackInStockButton';
import BrandLogo from '../../../ProductCard/BrandLogo';
import Bullets from '../../../ProductCard/Bullets';
import CompareButton from '../../../ProductCard/CompareButton/CompareButton';
import DeliveryInformation from '../../../ProductCard/DeliveryInformation';
import EnergyInformation from '../../../ProductCard/EnergyInformation/EnergyInformation';
import Heading from '../../../ProductCard/Heading';
import MoreInfo from '../../../ProductCard/MoreInfo';
import PricePod from '../../../ProductCard/PricePod/PricePod@default';
import ProductImage from '../../../ProductCard/ProductImage/ProductImage';
import PromoFlag from '../../../ProductCard/PromoFlag';
import ReviewRating from '../../../ProductCard/ReviewRating/ReviewRating';
import StockStatus from '../../../ProductCard/StockStatus';
import { Context } from '../../store/store';
import LargeListViewSkeleton from './Skeletons/LargeListViewSkeleton';

const LargeListViewContent = ({ product }) => {
	const [contextState] = useContext(Context);
	const { loaded } = contextState;

	const dispatch = useDispatch();

	if (!product) {
		return null;
	}

	if (!loaded) {
		return <LargeListViewSkeleton />;
	}

	return (
		<React.Fragment>
			<div className="flex flex-col p-2 w-1/4">
				<ProductImage {...product} />

				<EnergyInformation
					classes="text-center mt-4"
					energyRatingDetails={product.EnergyRatingDetails}
				/>

				<CompareButton
					classes="mt-auto"
					sku={product.Code}
					brand={product.Brand}
				/>
			</div>

			<div className="w-1/2 p-2">
				<a
					href={product.FullProductUrl}
					onClick={(event) => {
						event.preventDefault();
						window.location.assign(product.FullProductUrl);

						dispatch(listerClickThrough(product.Code));
					}}
					className="inline-block"
					data-testid="product-card-link">
					<BrandLogo {...product} />

					<Heading content={product.FullTitle} />
				</a>

				<ReviewRating {...product} />

				<PromoFlag {...product} />

				<Bullets content={product.FeatureDescriptions} />
			</div>

			<div className="flex flex-col justify-between p-2 w-1/4">
				<div className="text-right">
					<PricePod
						viewModel={product.PricePodViewModel}
						inStock={product.State !== 'OutOfStock'}
						{...product}
						exVat={true}
					/>
				</div>

				<div>
					{product.State !== 'OutOfStock' && (
						<DeliveryInformation
							deliveryInformation={product.DynamicDeliveryBulletsViewModel}
						/>
					)}

					{product.State === 'OutOfStock' && (
						<StockStatus
							stockStatus={product.State}
							productCode={product.Code}
						/>
					)}

					{product.State !== 'OutOfStock' && <AddToBasketButton {...product} />}

					{product.State === 'OutOfStock' && (
						<BackInStockButton {...product} classes="mt-2" />
					)}

					<MoreInfo classes="mt-2" {...product} />
				</div>
			</div>
		</React.Fragment>
	);
};

export default LargeListViewContent;
